"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MainMenu;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MainMenuModule = _interopRequireDefault(require("./MainMenu.module.scss"));

var _Stances = _interopRequireDefault(require("./components/Stances/Stances"));

var _Skills = _interopRequireDefault(require("./components/Skills/Skills"));

var _ExperienceBar = _interopRequireDefault(require("./components/ExperienceBar/ExperienceBar"));

var _Energy = _interopRequireDefault(require("./components/Energy/Energy"));

var _Actions = _interopRequireDefault(require("./components/Actions/Actions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MainMenu(_ref) {
  var character = _ref.character,
      skillBars = _ref.skillBars,
      _ref$showExpValueOnHo = _ref.showExpValueOnHover,
      showExpValueOnHover = _ref$showExpValueOnHo === void 0 ? false : _ref$showExpValueOnHo,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var energy = character.energy,
      experience = character.experience,
      experienceMax = character.experienceMax,
      isInAttackStance = character.isInAttackStance,
      isInRunStance = character.isInRunStance,
      isInSittingStance = character.isInSittingStance;
  var hp = energy.hp,
      mp = energy.mp,
      sp = energy.sp,
      hpMax = energy.hpMax,
      mpMax = energy.mpMax,
      spMax = energy.spMax;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Energy.default, {
    hp: hp,
    mp: mp,
    sp: sp,
    hpMax: hpMax,
    mpMax: mpMax,
    spMax: spMax
  }), /*#__PURE__*/_react.default.createElement(_ExperienceBar.default, {
    exp: experience,
    expMax: experienceMax,
    showValueOnHover: showExpValueOnHover
  }), /*#__PURE__*/_react.default.createElement(_Skills.default, {
    skillBars: skillBars
  }), /*#__PURE__*/_react.default.createElement(_Actions.default, null), /*#__PURE__*/_react.default.createElement(_Stances.default, null));
}